/* ==========================================================================
   Portal Layout
   Task F19: Wrapper for all /:slug/* routes that provides portal context
   ========================================================================== */

import { Outlet, useParams } from 'react-router-dom'
import { PortalNotFound } from '@/pages/PortalNotFound'

/**
 * Layout wrapper for all pharmacy portal routes (/:slug/*).
 * Extracts the slug from URL params and validates it.
 * Renders the nested route content via <Outlet />.
 *
 * Note: In the future, this could fetch and validate the portal config
 * from the API before rendering children.
 */
export function PortalLayout() {
  const { slug } = useParams<{ slug: string }>()

  // Basic validation - slug must exist and be non-empty
  // A more robust validation would fetch the portal config from API
  if (!slug || slug.trim() === '') {
    return <PortalNotFound />
  }

  // Validate slug format (lowercase letters, numbers, and hyphens only)
  const validSlugPattern = /^[a-z0-9][a-z0-9-]*[a-z0-9]$|^[a-z0-9]$/
  if (!validSlugPattern.test(slug)) {
    return <PortalNotFound />
  }

  // Render the nested route content
  return <Outlet />
}

export default PortalLayout
